<template>
  <div id="index">
    <!-- 头部 -->
    <!-- <Hezuo></Hezuo> -->

    <HeaderTop :headIndex="1"></HeaderTop>
    <!-- 推荐内容 -->
    <div class="main wrap flex_between">
      <!-- 消息列表 -->
      <div class="recommended flex_start">
        <div class=" message_list">
          <div class="recommended_title flex_center">
            <span class="flex_center recommended_title_li selected">消息列表</span>
          </div>
          <div class="recommended_list">
            <div class="recommended_ul" v-if="list_arr.length>0">
              <div class="recommended_li" :class="[{'unread':liem.read == 0 },{'choose':read_id==liem.message_id}]"
                v-for="(liem,index) in list_arr" @click="read(index)">
                <div class="li_top flex_between">
                  <span class="li_title">系统消息</span>
                  <span class="time">{{liem.create_time}}</span>
                </div>
                <div class="li_text clamp1" v-html="liem.content">

                </div>
              </div>

            </div>
            <div v-else class="complete">
              暂无消息
            </div>
          </div>
        </div>
        <div class="message_center">
          <div class="recommended_title flex_center">
            <span class="flex_center recommended_title_li">消息详情</span>
          </div>
          <div class="recommended_text flex_start" v-if="read_text.content">
            <i class="message_portrait"><img src="@/assets/img/app_logo.png" alt=""></i>
            <div class="text_div" v-html="read_text.content">

            </div>
          </div>
        </div>
      </div>
      <!-- 热门 -->
      <div class="hot_div hot">
        <div class="hot_title flex_center">
          <i><img src="@/assets/img/hot.png" alt=""></i>
          <span class="flex_center">热门</span>
        </div>
        <div class="">
          <hot :list="hotList_arr" @detailsFun="detailsFun"></hot>
        </div>
      </div>

    </div>
    <!-- 尾部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import HeaderTop from '@/components/assembly/HeaderTop.vue'; //头部模块
  import Footer from '@/components/assembly/Footer.vue'; //尾部模块
  import hot from '@/components/assembly/hot.vue'; //热门模块
  import listLi from '@/components/assembly/listLi.vue'; //列表数据模块
import Hezuo from '@/components/tool/hezuo.vue'

  import "@/assets/js/currency.js";
  import "@/assets/css/reset.css";

  //pc端
  // import "@/assets/css/index_min768.css";


  export default {
    name: 'index',
    data() {
      return {
        IMG_URL: this.$IMG_URL,
        recommended_index: 0, //导航 2推荐 3关注
        page: 1, //翻页
        list_arr: [], //列表数组
        hotList_arr: [], //热门列表

        read_id: 0, //当前读消息id
        read_text: {}, //阅读内容
      }
    },
    computed: {

    },
    components: {
      HeaderTop,
      Footer,
      hot,
      listLi,
      Hezuo
    },
    watch: {

    },
    methods: {
      read(index) { //查看消息
        this.read_id = this.list_arr[index].message_id;
        this.read_text = this.list_arr[index];
        let that = this;
        this.$post('read', {
          member_id: this.USER().id,
          message_id: this.read_id,
        }).then(res => {
          that.list_arr[index].read = 1;
          that.$nextTick(() => {
            that.addImg();
          })
        })
      },
      addImg() {
        $('.li_r_img img').on("click", function() {
          $(this).ImgZoomIn('');
        });
      },
      detailsFun(id) { //查看详情
        this.$router.push({
          path: '/column_details',
          query: {
            id: id,
            head_index: 2
          }
        });
      },
      judgeUser() { //判断用户数据
        if (this.USER() && this.USER() !== {}) {
          this.REFRESH_USER();
        } else {

        }
      },
      getList() { //获取列表数据
        let that = this;
        if (this.page == 1) {
          this.list_arr = [];
        }
        this.$get('system_message', {
          member_id: this.USER().id,
          limit: 10,
          page: this.page,
        }).then(res => {
          that.list_arr = that.list_arr.concat(res.data.data);
          if (that.list_arr) {
            // that.read(0)
          }
        })
      },
      getHotList() { //获取热门列表数据
        let that = this;
        this.$post('news_recomm', {
          type: 4,
          limit: 10,
          page: 1,
        }).then(res => {
          let data = res.data.data;
          that.hotList_arr = data;
        })
      },
      details(id, record_url) { //跳转页面

        if (this._isMobile()) {
          // alert("手机端");
          this.$router.push({
            path: 'min_message',
            query: {}
          });
        } else {
          // alert("pc端");

        }
      },

    },
    created() {

    },
    mounted() {
      this.judgeUser();
      this.getList();
      this.getHotList();
      // this.$router.replace("/index");
      if (this._isMobile()) {
        // alert("手机端");
        this.$router.replace('/m_home');
      } else {
        // alert("pc端");
        // this.$router.replace('/index');
      }

      let that = this;
      $('.recommended_list').scroll(function() {
        var scrollTop = $(this).scrollTop();
        var scrollHeight = $('.recommended_ul').height();
        var windowHeight = $(this).height();
        if (scrollTop + windowHeight + 2 >= scrollHeight) {
          that.page++;
          that.getList();
        }
      });
    }
  }
</script>
<style>


</style>
<style scoped>
  #index {
    min-width: 1280px;
  }

  .main {
    max-width: 1280px;
    min-width: 865px;
    margin: 0 auto;
    width: 100%;
    position: relative;
  }

  #index {
    background: #F5F3FB;
  }

  .main {
    padding: 13px 0;
    align-items: flex-start;
  }

  /* 推荐导航 */
  .recommended {
    width: 895px;
    /* width: 100%; */
    background: #fff;
    height: 80vh;
    border-radius: 10px;
  }

  .recommended .recommended_title {
    padding: 0 50px;
    border-bottom: .005rem solid #999999;
  }

  .recommended .recommended_title .recommended_title_li {
    height: 70px;
    padding: 0 6px;
    font-size: 18px;
    cursor: pointer;
    color: #333;
    font-weight: bold;
  }

  .recommended .recommended_title .recommended_title_li.selected {
    position: relative;
    font-weight: bold;
  }

  .recommended .recommended_title .recommended_title_li.selected::after {
    position: absolute;
    content: '';
    left: 0;
    right: 0;
    bottom: 1px;
    height: 2px;
    background: #F24D5B;
  }

  .recommended .message_list {
    width: 334px;
    border-right: 1px solid #DFDFDF;

  }

  .recommended .message_center {
    flex: 1;
  }

  .message_list .recommended_list {
    margin: 20px 0;
    height: 86%;
    overflow-y: auto;
  }



  .message_list .recommended_list .recommended_li {
    padding: 10px 20px;
    cursor: pointer;
    transition: all .5s ease;
  }

  .message_list .recommended_list .recommended_li:hover {
    background: #DFDFDF;
  }

  .recommended_li {
    position: relative;
  }

  .message_list .recommended_list .recommended_li.choose {
    background: #DFDFDF;
  }

  .recommended_li.unread::after {
    content: '';
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #F24D5B;
    top: 12px;
    left: 10px;
  }

  .recommended_li .li_title {
    font-size: 14px;
    font-weight: bold;
    color: #999;
  }

  .recommended_li .time {
    color: #666;
    font-size: 14px;
  }

  .recommended_li .li_text {
    color: #666;
    font-size: 14px;
  }

  .recommended_li.unread .li_title {
    color: #999;
  }

  .recommended_li.unread .time {
    color: #999;
  }

  .recommended_li.unread .li_text {
    color: #999;
  }

  .recommended_text {
    padding: 28px 30px;
  }

  .recommended_text .message_portrait {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    border: 1px solid #f46f7a;
    overflow: hidden;
    margin-right: 7px;
  }

  .recommended_text .text_div {
    padding: 15px 20px;
    flex: 1;
    border-radius: 10px;
    border: 1px solid #f46f7a;
    font-size: 14px;
    color: #333;
    line-height: 1.6em;
  }

  /* 热门 */
  .hot {
    width: 334px;
    background: #fff;
    border-radius: 10px;
    position: absolute;
    right: 0;
    top: 13px;
    /* position: fixed;
    right: calc((100% - 1280px) / 2);
    top: 74px; */
  }

  .hot .hot_title {
    border-bottom: .005rem solid #999999;
  }

  .hot .hot_title>i {
    width: 15px;
    margin-right: 11px;
  }

  .hot .hot_title>span {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    height: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pc_viwe/message.vue